import * as React from 'react';
import { useSelector } from 'react-redux';
import { PaymentAnnualSummaryView, PaymentSummaryView, UserView } from 'cb-model';
import { BlockSequence, List, PageTitle, QueryMulti, Section, selectUser, useCacheRecord } from 'gossamer-front-end';
import { UserStripeConnectPanel } from './StripeConnectPanel';
import { getFilter } from 'packages/gossamer-unified/FilterUtils';
import { PERSONAL_INSTITUTION_ID } from 'packages/cb-unified';

export const UserPaymentsSummary = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  const userRecord = useCacheRecord(UserView, user?.userId, !user?.userId);

  return (
    <>
      <PageTitle title="Payments" subtitle="Ticket revenue and payment status for your events" />
      <Section
        title="Stripe Connect"
        subtitle="We take payments from users through Stripe and use Stripe to pay you, therefore you need to set yourself up with Stripe to receive payouts."
      >
        <UserStripeConnectPanel userRow={userRecord?.data} />
      </Section>
      <Section title="Pay-out Summary" subtitle="Total expected and actual pay-out amounts over the last 12 months">
        <QueryMulti
          entity={PaymentAnnualSummaryView}
          render={BlockSequence}
          queryOptions={{
            where: {
              and: [
                getFilter('user_id', 'eq', user?.userId),
                getFilter('institution_id', 'eq', PERSONAL_INSTITUTION_ID),
              ],
            },
          }}
          showSettingsControl={false}
          showPaginator="never"
        />
      </Section>
      <Section title="Pay-outs per Event" subtitle="Expected and actual pay-out amounts per event">
        <p>
          This list shows you the number of paid bookings per event, the total amount you will be paid (or have been
          paid), as of this moment, and the amounts that have been paid back to users due to cancelling their bookings
          or due to the event being cancelled.
        </p>
        <QueryMulti
          entity={PaymentSummaryView}
          render={List}
          queryOptions={{
            where: {
              and: [
                getFilter('user_id', 'eq', user?.userId),
                getFilter('institution_id', 'eq', PERSONAL_INSTITUTION_ID),
              ],
            },
          }}
        />
      </Section>
    </>
  );
};
